<template>
  <div class="full-size">
    <div class="full-size" v-if="isPresentingOrBackstage && !sharePresentation">
      <QuizSlideContent />
    </div>
    <div v-if="sharePresentation || !isPresentingOrBackstage" class="full-size px-3">
      <CanvasHints v-if="isCanvasHintsVisible" />
      <SlideContentWrapper />
    </div>
  </div>
</template>

<script>
import QuizSlideContent from '@/components/presentations/contents/QuizSlideContent.vue'
import CanvasHints from '@/components-v2/presentation-editor/middle/hints/CanvasHints.vue'
import SlideContentWrapper from '@/components-v2/presentation-editor/middle/common/SlideContentWrapper.vue'

export default {
  components: {
    QuizSlideContent,
    CanvasHints,
    SlideContentWrapper,
  },
  props: {
    isCanvasHintsVisible: {
      type: Boolean,
      default: false,
    },
    sharePresentation: {
      type: Boolean,
      default: false,
    },
    isPresentingOrBackstage: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
